// extracted by mini-css-extract-plugin
module.exports = {"root":"LandownerReferral_root__36pGb","lastUpdated":"LandownerReferral_lastUpdated__EayJq","disc":"LandownerReferral_disc__1dwxQ"};